import {createContext, useState} from "react";

export const RoleContext = createContext({})

export const Provider = (props) => {
    const {children} = props;

    let emptyRole = {
        id: "",
        code: "",
        name: "",
        type: null,
        enabled: true,
        description: ""
    }

    const [role, setRole] = useState(emptyRole);
    const [roles, setRoles] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [roleDialog, setRoleDialog] = useState(false);

    const resetRole = () => {
        setRole(emptyRole);
    };

    // Make the context object:
    const roleContext = {
        role,
        resetRole,
        setRole,
        roles,
        setRoles,
        submitted,
        setSubmitted,
        roleDialog,
        setRoleDialog,
    };

    // pass the value in provider and return
    return <RoleContext.Provider value={roleContext}>{children}</RoleContext.Provider>;
}

export const {Consumer} = RoleContext;
